import { Modal } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { highlightedDivStyle } from '~/src/dash/components/layout/common';
import {
  ButtonV2,
  Col,
  Cols,
  IndependentSelect,
  Row,
  Rows,
  spacing,
  Text,
} from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const labelWidth = 108;
const rowHeight = 40;

export interface IProps {
  active: boolean;
  list: ISelectOption[];
  showPrefixID: boolean;

  onClose: () => void;
  onUpdate: (name?: string, id?: number) => void;
  handleItemAcceptClick: (selectedGroup: Set<number>) => void;
}

const AddToBidderGroupDialog: React.FC<IProps> = ({
  active,
  list,
  onClose,
  onUpdate,
  handleItemAcceptClick,
}) => {
  // Define state variables using useState hook
  const [options, setOptions] = useState<ISelectOption[]>(list);
  const [selectedGroupID, setSelectedGroupID] = useState<Set<number>>(new Set([]));

  // Effect hook to update state when props change
  useEffect(() => {
    setOptions(list);
  }, [list]);

  // Handle changes in the search dropdown
  const handleItemAccept = (id: Set<string>) => {
    const updatedSet = new Set<number>([...selectedGroupID, ...Array.from(id).map(Number)]);
    handleItemAcceptClick(updatedSet); // Pass the updated list back to the parent
    setSelectedGroupID(updatedSet);
  };

  // Close the modal
  const handleClose = () => {
    if (onClose) {
      setSelectedGroupID(new Set([]));
      onClose(); // Invoke the onClose prop function
    }
  };

  // Update the modal
  const handleUpdate = () => {
    const selectedID = [...selectedGroupID][0];
    if (selectedID) {
      onUpdate('', selectedID);
    }
  };

  return (
    <div>
      <Modal
        open={active}
        onClose={handleClose}
        aria-labelledby='add-to-bidder-group-list-modal'
        aria-describedby='add-to-bidder-group-list-modal'
      >
        <Rows
          smallVerticalPadding
          extraLargeHorizontalPadding
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '720px',
            height: '460px',
            ...highlightedDivStyle,
          }}
        >
          <Row noHorizontalPadding verticalPadding>
            <Text extraLarge bold>
              Add to Bidder Group
            </Text>
            <Text>Select bidder group</Text>
          </Row>
          {/* Forms */}
          <Row noPadding>
            <Rows gap={spacing.small} style={{ alignItems: 'center', justifyContent: 'center' }}>
              <Row paddingTop='20px' noPadding height={rowHeight} style={{ width: '100%' }}>
                <Cols gap={spacing.extraLarge} style={{ alignItems: 'end' }}>
                  <Col width={labelWidth}>
                    <Text small bold>
                      Bidder Group
                    </Text>
                  </Col>
                  <Col flex>
                    <IndependentSelect
                      handleApplySelect={handleItemAccept}
                      placeholder='Select Bidder Group'
                      listLabel='Bidder Groups'
                      singularLabel='Bidder Group'
                      selectedLimit={1}
                      disableSort
                      isSelectionRequired
                      options={options.map((item) => ({
                        id: item.id,
                        label: item.label,
                      }))}
                      selectedOptionIDs={selectedGroupID}
                      key='bidderGroup'
                      maxWidth={280}
                    />
                  </Col>
                </Cols>
              </Row>
            </Rows>
          </Row>
          <Row noHorizontalPadding paddingTop='250px'>
            <Cols gap={spacing.large} style={{ justifyContent: 'flex-end', alignItems: 'end' }}>
              <Col>
                <ButtonV2 small onClick={handleUpdate}>
                  Save
                </ButtonV2>
              </Col>
              <Col>
                <ButtonV2 small onClick={handleClose} clearBackground color={publicaColors.blue}>
                  Cancel
                </ButtonV2>
              </Col>
            </Cols>
          </Row>
        </Rows>
      </Modal>
    </div>
  );
};

export default AddToBidderGroupDialog;
